import { ensureString } from '@/mixins/useEnsure'
import BrowserService from '@/services/browserService'

export default (user, product, params) => {
  const payload = ({
    event: 'view_item',
    platform: BrowserService.platform(),
    sessionId: BrowserService.sessionId(),
    ecommerce: {
      currency: product.currencyCode,
      products: [
        {
          id: ensureString(product.id),
          name: product.name,
          favorite: params.isFavorite,
          categories: product.categories.map((c) => {
            return c.title
          }),
          labels: product.properties.map((p) => {
            return p.name
          }),
          availability: 'stock',
          price: Number(product.priceWithoutVat),
          currency: product.currencyCode,
          discount: 0,
        },
      ],
      user: user,
    },
    _clear: true,
  })
  window.dataLayer?.push(payload)
}
